<template>
    <div class="discountServiceList">
        <DiscountServiceItem
            class="discountServiceItem"
            v-for="item in list"
            :key="item.id"
            :item="item"
            :isShowStoreInfo="store_home !== 'store_home'"
            @onClickItem="onGoToPage"
        />
    </div>
</template>

<script>
import DiscountServiceItem from '@/components/discountServiceItem/discountServiceItem'

export default {
    name: 'discountServiceList',
    components : {
        DiscountServiceItem
    },
    data () {
        return {
            goods: {},
        }
    },
    computed: {
    },
    props: {
        /**
         * 列表数据源
         */
        list: {
            type: Array,
            required: true,
            default () {
                return []
            }
        },
    },
    watch: {
    },
    created () {
        const { from } = this.$route.query
        this.store_home = from
        // console.log(this.$route, '11')
    },
    activated () {
    },
    mounted () {
    },
    methods: {
        onGoToPage (item) {
            const {distribution_code}  = this.$route.query
            this.$router.push({
                name: 'marketingActivities',
                query: {
                    distribution_code,
                    sstore_id: item.store_id,
                    package_id: item.activity_id
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/stylus/variables.styl";
@import "~@/assets/stylus/mixin.styl";

.discountServiceList
    padding 20px
    .discountServiceItem
        margin-bottom 20px
</style>
